import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { apiResponse, apiError } from '../schemas/common.schema';

const c = initContract();

export const ContactResponseSchema = z.object({
  _id: z.string(),
  contact_token: z.string().optional(),
  contact_created_at: z.union([z.string(), z.date()]).optional(),
  contact_modified_at: z.union([z.string(), z.date()]).optional(),
  contact_fullname: z.string().optional(),
  contact_phones: z.array(z.any()).optional(),
  contact_email: z.string().optional(),
  contact_location: z.any().optional(),
  contact_messenger: z.any().optional(),
  contact_source: z.string().optional(),
  contact_tags: z.array(z.string()).optional(),
  contact_locale: z.string().optional(),
  contact_notes: z.array(z.any()).optional(),
  contact_progress: z.array(z.any()).optional(),
  contact_status_id: z.number().optional(),
  contact_archivated: z.boolean().optional(),
  contact_last_interaction: z.union([z.string(), z.date()]).optional(),
  contact_owner_id: z.string().optional(),
  contact_maker_id: z.string().optional(),
  account_id: z.string().optional(),
});

export const getContactsQuery = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().optional(),
  accountId: z.string().optional(),
  missionerId: z.string().optional(),
  search: z.string().optional(),
});

export const contactsContract = c.router({
  getContacts: {
    method: 'GET',
    path: '/contacts',
    query: getContactsQuery,
    responses: { 200: apiResponse(z.array(ContactResponseSchema)) },
  },
  getContactById: {
    method: 'GET',
    path: '/contacts/:contact_id',
    pathParams: z.object({ contact_id: z.string() }),
    responses: {
      200: apiResponse(ContactResponseSchema),
      404: apiError,
    },
  },
});

export type ContactResponseDto = z.infer<typeof ContactResponseSchema>;
